import { Component, Input, OnInit } from '@angular/core';
import { FormWizardPageElement } from 'src/app/models/form-wizard-template.model';
import { ControlContainer, NgForm } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
  selector: 'app-date-input-element',
  templateUrl: './date-input-element.component.html',
  styleUrls: ['./date-input-element.component.scss'],
  viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class DateInputElementComponent implements OnInit {
  @Input() element: FormWizardPageElement | undefined;
  @Input() formValues: any | undefined;

  public internalValue?: Date;

  constructor() { }

  ngOnInit(): void {
    const elementName = this.getName();
    let currentValue = this.element?.defaultValue ?? '';

    if (elementName !== '' && !_.isNil(this.formValues[elementName]) && this.formValues[elementName] !== '') {
      currentValue = this.formValues[elementName];
    }

    this.internalValue = !_.isNil(currentValue) && currentValue !== '' ? new Date(currentValue) : undefined;
  }

  public getControlName(): string {
    return 'input' + this.getName();
  }

  public getName(): string {
    return this.element?.name ?? '';
  }

  public getLabel(): string {
    return this.element?.label ?? '';
  }

  public getPattern(): string {
    return this.element?.pattern ?? 'dd/MM/yyyy';
  }

  public isLabelVisible(): boolean {
    return this.getLabel() !== '' && this.isControlVisible();
  }

  public isControlVisible(): boolean {
    return !_.isNil(this.element) && !_.isNil(this.formValues);
  }

  public isRequired(): boolean {
    return this.element?.required ?? false;
  }

  public onValueChange(): void {
    if (!_.isNil(this.internalValue)) {
      this.formValues[this.getName()] = (moment(this.internalValue)).format('YYYY-MM-DD');
    } else {
      this.formValues[this.getName()] = this.internalValue;
    }
  }

  public getMaxValue(): Date {
    let result = new Date(9999, 1, 1);

    if (!_.isNil(this.element) && !_.isNil(this.element.maxValue)) {
      result = new Date(this.element.maxValue.toString());
    }

    return result;
  }
}
